import React, { useCallback } from 'react'

import { WarningTwoIcon } from '@chakra-ui/icons'
import {
  Alert,
  AlertDescription,
  AlertIcon,
  Box,
  Icon,
  List,
  ListItem,
  Stack,
  Text,
} from '@chakra-ui/react'
import { useFormikContext } from 'formik'
import { useSelector } from 'react-redux'

import { districtOptions } from '../../../../constants'
import { convertDistrictToNumeric } from '../../../../utils'
import { SearchOption, SearchOptions, SearchSelect } from '../../../ui/select'

const SelectDistrictPage = () => {
  const user = useSelector(state => state.auth.user)

  const { values, setFieldValue } = useFormikContext()
  const selected = values.district

  const filterOptions = useCallback(
    searchTerm =>
      districtOptions.filter(district =>
        district.toString().startsWith(searchTerm)
      ),
    []
  )
  const handleEnter = (e, { searchTerm }) => {
    if (e.key === 'Enter') {
      let options = filterOptions(searchTerm)
      if (options.length > 0) setFieldValue('district', options[0])
    }
  }
  return (
    <Stack>
      <Stack gap={0}>
        <Text as='b'>Selected district </Text>
        <Text fontSize='md'>District {selected}</Text>
      </Stack>
      <SearchSelect>
        <SearchOptions
          inputProps={{ placeholder: 'Select district...' }}
          enableClear={false}
          onKeyDown={handleEnter}
        >
          {({ searchTerm }) =>
            filterOptions(searchTerm)?.map(district => {
              return (
                <SearchOption
                  key={district}
                  option={{
                    label: district,
                    value: convertDistrictToNumeric(district),
                  }}
                  onSelect={value => {
                    if (value === selected) return
                    setFieldValue('district', value)
                    setFieldValue(
                      'assigned_staff',
                      values.assigned_staff?.filter(
                        staff => staff.is_admin || staff.id === user.id
                      )
                    )
                  }}
                >
                  {district}
                </SearchOption>
              )
            })
          }
        </SearchOptions>
      </SearchSelect>

      {values.assigned_staff?.length > 0 && (
        <Stack>
          <Alert status='warning'>
            <AlertIcon />

            <AlertDescription>
              On changing the district, <b>assigned staff</b> that are not from
              that district (excluding admin staff and yourself) will be
              removed.
            </AlertDescription>
          </Alert>
          <Box>
            <Text as='b'>Assigned Staff</Text>
            <List>
              {values.assigned_staff?.map(staff => {
                let labels = []
                labels.push(
                  `District ${convertDistrictToNumeric(staff.district)}`
                )
                if (staff.is_admin) labels.push('Admin')
                if (staff.id === user.id) labels.push('Yourself')
                let toRemove = !(staff.is_admin || staff.id === user.id)
                return (
                  <ListItem key={staff.id}>
                    {toRemove && <Icon as={WarningTwoIcon} mr={1} />}
                    {staff.full_name}
                    {` (${labels.join(', ')})`}
                  </ListItem>
                )
              })}
            </List>
          </Box>
        </Stack>
      )}
    </Stack>
  )
}
export default SelectDistrictPage
